import React from 'react';
import '../styles/helper.css';

// Custom designed heading tag
const CustomTypoH1 = ({ typo }) => <h1 className='typo-h1'>{typo}</h1>;

const CustomTypoH2 = ({ typo }) => <h2 className='typo-h2'>{typo}</h2>;

const CustomTypoH3 = ({ typo }) => <h3 className='typo-h3'>{typo}</h3>;

const CustomTypoH4 = ({ typo }) => <h4 className='typo-h4'>{typo}</h4>;

const CustomTypoH5 = ({ typo }) => <h5 className='typo-h5'>{typo}</h5>;

const CustomTypoH6Gray = ({ typo }) => <h6 className='typo-h6-gray'>{typo}</h6>;

const CustomTypoPara = ({ typo }) => <p className='typo-para'>{typo}</p>;

const CustomTypoLighth3 = ({ typo }) => <h3 className='custom-typo-light-h3'>{typo}</h3>;


export {
    CustomTypoH1, CustomTypoH2, CustomTypoPara, CustomTypoH3, CustomTypoH4, CustomTypoH5, CustomTypoH6Gray,
    CustomTypoLighth3
};